import { useIntl } from 'react-intl';
import { SenderSource } from '@enuan/chat__utils';
import { Message } from '../UI/Message/Message';
import { frameStateContext } from '../../contexts/frame/context';
import { genericMessages } from '../../generic.i18n';
import type { IClientMessage } from '../../interfaces/IClientMessage';
import React, { useContext } from 'react';
import { styled } from '@mui/material/styles';
import classNames from 'classnames';

const ORIENTATION_ALERT_MESSAGE = {
	client_id: 'orientation-alert',
	sender: SenderSource.AGENT,
	_meta: {},
} as IClientMessage;

export const OrientationAlert = styled(
	({ className }: { className?: string }) => {
		const {
			isOpen: { isOpen },
		} = useContext(frameStateContext);

		const intl = useIntl();
		const orientation_alert = intl.formatMessage(
			genericMessages.orientation_alert,
		);
		if (!isOpen) return null;
		return (
			<Message
				message={ORIENTATION_ALERT_MESSAGE}
				className={classNames('orientation_alert', className)}
				customHeader={null}
				customFooter={null}
				customExtra={null}
				customAvatar={null}
			>
				{orientation_alert}
			</Message>
		);
	},
	{ target: 'OrientationAlert-root', label: 'OrientationAlert' },
)({
	display: 'none',
});
